import React from 'react';

import { useTranslation } from 'react-i18next';

import AdminService from '../../../../../services/AdminService';
import TableView from '../../TableView';

export default function WorkShifts({ setItemCount }) {
  const { t } = useTranslation();

  const columns = [
    {
      name: t(
        'dashboardComponents.Console.RefDataManagement.WorkShifts.workShiftName'
      ),
      field: 'name',
      sortable: true,
    },
    { name: t('common.sortOrder'), field: 'sortOrder', sortable: true },
    {
      name: t('common.notes'),
      field: 'note',
      sortable: false,
    },
    {
      name: t('common.createdOn'),
      field: 'createdAt',
      sortable: true,
      type: 'date',
    },
  ];

  return (
    <TableView
      setItemCount={setItemCount}
      dataName="Work Shift"
      getDataHandler={AdminService.getWorkShifts}
      deleteDataHandler={AdminService.deleteWorkShift}
      createDataHandler={AdminService.createWorkShift}
      updateDataHandler={AdminService.updateWorkShift}
      viewLeftColumnFields={[{ label: 'Name', field: 'name' }]}
      viewRightColumnFields={[
        { label: t('common.sortOrder'), field: 'sortOrder' },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
        },
      ]}
      formLeftColumnFields={[
        {
          label: 'Name',
          field: 'name',
          validation: ['string', 'required'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.WorkShifts.workShiftNameHere'
          ),
        },
      ]}
      formRightColumnFields={[
        {
          label: t('common.sortOrder'),
          field: 'sortOrder',
          validation: ['string', 'required', 'numbers'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.WorkShifts.specifySortOrderHere'
          ),
          maxLength: 5,
        },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
          validation: ['string'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.WorkShifts.enterAnySpecificNotesAboutTheWorkShift'
          ),
        },
      ]}
      columns={columns}
    />
  );
}
